import { render } from "./ConfLoadModal.vue?vue&type=template&id=59ff40c5"
import script from "./ConfLoadModal.vue?vue&type=script&lang=js"
export * from "./ConfLoadModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/molinam/gitlab/techbio2025-vue-app/vue-mobile-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__